import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Alert, Autocomplete, Backdrop, Button, CircularProgress, Snackbar, Stack, TextField, Typography } from "@mui/material";
import SkeletonLoading from "../../../../components/SkeletonLoading";
import '../../../../styles/AppCss.css'
import { Padding, PaletaColor } from "../../../../styles/StylesConstantes";
import { CssTextField } from "../../../../styles/styles";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { optionsEstado } from "../../../../constantes/constantes";



function AddSubCategoriaPage() {
    const [cargando, setCargando] = useState(false);
    const [descripcion, setDescripcion] = useState('');
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [loadingGuardar, setLoadingGuardar] = useState(false);
    const [editable, setEditable] = useState(false);
    const [categoria, setCategoria] = useState('');

    const params = useParams();
    const localizacion = useLocation();
    // console.log("params", localizacion);

    const navigate = useNavigate();


    useEffect(() => {
        // handleListarProductos();
        setTimeout(() => {
            setCargando(true);

            if (params?.id) {
                setEditable(true);
                setDescripcion(localizacion?.state?.data?.name);
            } else {
                setEditable(false);
                setDescripcion('');
            }
        }, 1000);
    }, [params]);




    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };

    //=========================================================funcion para cancelar y volver a la lista
    const handleCancelar = () => {
        window.history.back();
    };

    //=========================================================funcion para guardar
    const handleGuardar = () => {
        let body = {};
        body.nombre = descripcion;

        console.log("body", body);

        //validar campos que no esten vacios
        if (descripcion.trim() === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('Todos los campos son obligatorios');
        } else {

            setLoadingGuardar(true);


            setTimeout(() => {
                setLoadingGuardar(false);

                setTimeout(() => {
                    setOpen(true);
                    setSeverity('success');
                    setMensaje('Guardado con exito');
                    // window.history.back();

                    setTimeout(() => {
                        navigate('/app/admin/obsequios/subcategorias');
                    }, 1000);
                }, 1000);

            }, 2000);
        }
    };


    //=============================================funcion para seleccionar una categoria
    const handleSelectedCategoria = (event) => {
        console.log("event", event);
        setCategoria(event);
    };


    return (
        <HeaderCustom>
            <div style={{
                marginTop: Padding.P2,
                padding: Padding.P2,
            }}>

                <div style={{
                    backgroundColor: PaletaColor.BLANCO,
                    borderRadius: Padding.P1,
                    padding: Padding.P3,
                }}>
                    {cargando ? (
                        <div style={{}}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: Padding.P2
                            }}>
                                <div style={{ flex: 1 }}>
                                    <Typography variant={'h5'} style={{ marginBottom: Padding.P2 }}>
                                        {editable ? 'Editar Categoria' : 'Crear Categoria'}
                                    </Typography>


                                    <CssTextField
                                        value={descripcion}
                                        onChange={(e) => setDescripcion(e.target.value)}
                                        variant="outlined"
                                        margin="normal"
                                        fullWidth
                                        label="Nombre"
                                        autoCapitalize='none'
                                        autoCorrect={false}
                                        style={{
                                            marginTop: Padding.P1,
                                            width: '100%'
                                        }}
                                    />
                                </div>

                                <div style={{ flex: 1, marginLeft: Padding.P2 }}>
                                    <div>
                                        <Typography variant={'subtitle1'} style={{ marginBottom: Padding.P2 }}>
                                            Categoría
                                        </Typography>
                                    </div>

                                    <Autocomplete
                                        disablePortal
                                        options={optionsEstado}
                                        sx={{ width: '50%' }}
                                        renderInput={(params) => <TextField {...params} label="Seleccione" />}
                                        onInputChange={(event, newInputValue) => {
                                            handleSelectedCategoria(newInputValue);
                                        }}
                                        value={categoria}

                                    />
                                </div>
                            </div>


                            <Stack direction="row" spacing={5} style={{ marginTop: Padding.P3 }}>
                                <Button variant="contained" onClick={handleGuardar}>
                                    Guardar
                                </Button>

                                <Button variant="outlined" onClick={handleCancelar}>
                                    Cancelar
                                </Button>
                            </Stack>



                        </div>
                    ) : <SkeletonLoading />
                    }
                </div>
            </div>

            <Backdrop open={loadingGuardar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default AddSubCategoriaPage;